import Vue from "vue";
import Router from "vue-router";
import Home from '@/components/Home.vue';
import KRWertung from '@/components/KRWertung.vue';
import KRWertungFreestyle from '@/components/KRWertungFreestyle.vue';
import KRWertungHosinsul from '@/components/KRWertungHosinsul.vue';

Vue.use(Router);

export default new Router({
    mode: "history",
    linkExactActiveClass: '',
    linkActiveClass: '',
    base: process.env.BASE_URL,
    component: {
        Home, KRWertung, KRWertungFreestyle, KRWertungHosinsul
    },
    routes: [
        {
            path: '/Home',
            name: 'Home',
            component: Home
        },
        {
            path: '/KRWertung',
            name: 'KRWertung',
            component: KRWertung
        },
        {
            path: '/KRWertungFreestyle',
            name: 'KRWertungFreestyle',
            component: KRWertungFreestyle
        },
        {
            path: '/KRWertungHosinsul',
            name: 'KRWertungHosinsul',
            component: KRWertungHosinsul
        },
    ]
});